(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .factory('sensionMessage', sensionMessage);

  sensionMessage.$inject = ['gettext', 'translationService', 'mtypes', 'sensionData', '$sce'];

  function sensionMessage(gettext, translationService, mtypes, sensionData, $sce) {
    var messages = {
      'default': ''
    };

    messages[sensionData.ON_MOBILE] = gettext('This %s is not supported on your mobile browser. Please take this %s with the Mindflash iPad app or a computer with a webcam.');
    messages[sensionData.NO_FLASH] = gettext('This %s requires the use of a webcam and <a href=\"http://get.adobe.com/flashplayer/\" target=\"_blank\">Adobe Flash Player 11.5</a> and higher.  Please upgrade to the latest version of <a href=\"http://get.adobe.com/flashplayer/\" target=\"_blank\">Adobe Flash Player</a>.');
    messages[sensionData.NO_CAMERA] = gettext('This %s requires the use of a webcam. Please take this %s on a computer with a webcam.');
    messages[mtypes.sensionUsage.requireEngagement] = gettext('This %s requires the use of your webcam. Video will not be recorded nor streamed.');
    messages[mtypes.sensionUsage.measureEngagement] = gettext('To help the trainer improve this %s, this %s will use your webcam. Video will not be recorded nor streamed.');

    var service = {
      error: error,
      info: info
    };

    return service;

    ///////////////

    function error(lookup, cModuleType) {
      var partialMessage = parselookup(lookup);

      if (lookup === 'on-mobile' || lookup === 'no-camera') {
        return partialMessage(cModuleType, cModuleType);
      } else if (lookup === 'no-flash') {
        return $sce.trustAsHtml(partialMessage(cModuleType));
      } else {
        return partialMessage(cModuleType);
      }
    }

    function info(lookup, cModuleType) {
      if (cModuleType === 'online') cModuleType = 'cModule';
      var partialMessage = parselookup(lookup);

      if (lookup == mtypes.sensionUsage.requireEngagement)
        return partialMessage(cModuleType);
      if (lookup == mtypes.sensionUsage.measureEngagement)
        return partialMessage(cModuleType, cModuleType);

      return partialMessage(cModuleType);
    }

    function parselookup(lookup) {
      lookup = lookup || 'default';

      return _.partial(translationService.sprintf, messages[lookup]);
    }
  }

})();
